import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Button,
  Row,
  Col,
  Input
} from 'reactstrap';
import * as commonActions from '@common/common.action';
import { useDispatch } from 'react-redux';
import IntlMessage from '../../../../../../helpers/intlMessage';
import { useIntl } from 'react-intl';

export default function ModalLocalizacao(props) {
  const [modalAberto, setModalAberto] = useState(false);
  const backdrop = !props.backdrop ? false : props.backdrop;
  const keyboard = props.keyboard === undefined ? true : props.keyboard;
  const dispatch = useDispatch();
  const intl = useIntl()

  useEffect(() => {
    setModalAberto(props.showModalLocalizacao);
    dispatch(commonActions.showModal(props.showModalLocalizacao));
  }, [props.showModalLocalizacao]);

  useEffect(() => {
    changeLocalizacao(props.localizacaoArquivamento);
  }, [props.localizacaoArquivamento]);

  function toggle() {
    setModalAberto(!modalAberto);
    dispatch(commonActions.showModal(!modalAberto));
    props.onModal(!modalAberto);
  }

  function changeLocalizacao(el) {
    if (el.length > 200) {
      return;
    }
    props.setLocalizacaoArquivamento(el);
  }

  function textLength() {
    const carac = 200 - props.localizacaoArquivamento.length;
    let msn = `${intl.formatMessage({id: 'general.materialArchiving.remain'})} ${carac} ${intl.formatMessage({id: 'general.materialArchiving.characters'})}`;

    if (carac === 1) {
      msn = `${intl.formatMessage({id: 'general.materialArchiving.remain'})} ${carac} ${intl.formatMessage({id: 'general.materialArchiving.characters'})}`;
    } else if (carac === 0) {
      msn = `${intl.formatMessage({id: 'general.materialArchiving.maximumCharacters'})}`;
    }

    return msn;
  }
  return (
    <React.Fragment>
      <div>
        <Modal
          className='modal-confirm'
          backdrop={backdrop}
          keyboard={keyboard}
          centered
          isOpen={modalAberto}
          toggle={toggle}
        >
          <ModalHeader toggle={!props.close ? toggle : props.close}>
            <IntlMessage id="general.materialArchiving.materialLocation" />
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col>
                <FormGroup>
                  <Label><IntlMessage id="general.materialArchiving.location" />:</Label>
                  <Input
                    type='textarea'
                    placeholder={`${intl.formatMessage({id: 'general.materialArchiving.informTheLocationStored'})}`}
                    rows={3}
                    value={props.localizacaoArquivamento}
                    onChange={e => changeLocalizacao(e.target.value)}
                  />
                  <div className='texto-observacao'>{textLength()}</div>
                </FormGroup>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              onClick={!props.cancelar ? toggle : props.cancelar}
              className={`button-cancel`}
              color='secondary'
            >
              <IntlMessage id="general.materialArchiving.close" />
            </Button>
            <Button
              className={`button-confirm`}
              onClick={props.salvarLocalizacao}
              color='primary'
              disabled={!props.localizacaoArquivamento}
            >
              <IntlMessage id="general.materialArchiving.toMove" />
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/pages/arquivamento/tabs/Arquivamento/modais/Localizacao/index.js